function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { AttrsSchema, Component, jsx } from 'panel';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { SelectEl } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { InputEl } from 'common/components/input';
import { IronContextRegistry } from 'common/report/context-registry';
import { parseNumber } from 'common/util';
import css from './index.inline.styl';
type FlowsCardinalityControlAttrs = {
  cardinality: number;
};
export interface FlowsCardinalityControlJsxProps {
  attrs: FlowsCardinalityControlAttrs;
  on: {
    change: (ev: CustomEvent<number>) => void;
  };
}
export class FlowsCardinalityControl extends Component<EmptyObj, FlowsCardinalityControlAttrs, unknown, unknown, IronContextRegistry> {
  static get attrsSchema(): AttrsSchema<FlowsCardinalityControlAttrs> {
    return _objectSpread(_objectSpread({}, super.attrsSchema), {}, {
      cardinality: "number"
    });
  }
  get config() {
    return {
      css,
      useShadowDom: true,
      contexts: ["i18n" as const],
      template: () => {
        const t = this.getContext("i18n").t;
        return <SelectEl sel='.cardinality-control' attrs={{
          theme: SelectTheme.Secondary,
          'selected-option': t("flows.cardinality.rows-label", {
            count: this.attr("cardinality")
          }),
          'never-show-caret': true
        }}>
            <div sel='.cardinality-control-container' attrs={{
            slot: "body"
          }}>
              <h4>{t("flows.cardinality.rows-title")}</h4>
              <h5>{t("flows.cardinality.rows-description")}</h5>
              <div sel='.option-container'>
                <InputEl attrs={{
                type: "number",
                size: "medium"
              }} props={{
                value: this.attr("cardinality").toString()
              }} on={{
                change: ev => {
                  const value = parseNumber(ev.detail.value);
                  if (value !== null && value >= 1) {
                    this.dispatchEvent(new CustomEvent("change", {
                      detail: parseNumber(ev.detail.value)
                    }));
                  }
                }
              }} />
                {String(t("flows.cardinality.rows-title")).toLowerCase()}
              </div>
            </div>
          </SelectEl>;
      }
    };
  }
}
export const FlowsCardinalityControlEl = defineAndMakeJsxFactory<FlowsCardinalityControlJsxProps>("flows-cardinality-control", FlowsCardinalityControl);
export const FlowsCardinalityControlReact = panel2react<FlowsCardinalityControlJsxProps>("flows-cardinality-control", FlowsCardinalityControl);